var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.0441C24.5 5.39238 19.1274 0 12.5 0C5.87264 0 0.5 5.39238 0.5 12.0441C0.5 17.6923 4.37456 22.4319 9.60128 23.7336V15.7248H7.12688V12.0441H9.60128V10.4581C9.60128 6.35879 11.4498 4.45872 15.4597 4.45872C16.22 4.45872 17.5318 4.60855 18.0685 4.75789V8.0941C17.7853 8.06423 17.2933 8.0493 16.6822 8.0493C14.7147 8.0493 13.9544 8.79748 13.9544 10.7424V12.0441H17.8741L17.2006 15.7248H13.9544V24C19.8954 23.2798 24.5 18.202 24.5 12.0441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a612db41bc978758b9cb72f9a31a7910.svg";
export { ForwardRef as ReactComponent };